/* Pure helpers for the customer-stories app */

/* Sort an array of term objects alphabetically */
export const sortTerms = (a, b) => {
	if (a.term < b.term) {
		return -1;
	}

	if (a.term > b.term) {
		return 1;
	}

	return 0;
};

/* Set a taxonomy filter value on the store, normalising to an array */
export const setFilter = (store, selection, type = 'topics') => {
	if (Array.isArray(selection)) {
		store.filter[type] = selection.length > 0 ? selection : [];
	} else if (selection) {
		store.filter[type] = [selection];
	} else {
		store.filter[type] = [];
	}
};

/* Decorate each story with topic/industry slug Sets so subsequent filter */
/* operations can do O(1) membership checks instead of repeated Array#includes. */
export const decorateStoriesWithSlugs = stories => stories.map(story => ({
	...story,
	_topicSlugs: new Set((story.taxonomies?.topic || []).map(topic => topic.slug)),
	_industrySlugs: new Set((story.taxonomies?.industry || []).map(industry => industry.slug)),
}));

/* Filter the supplied stories by arrays of taxonomy slugs */
export const getFilteredStories = (stories, topics, industries) => stories.filter(story => {
	/* Use precomputed Sets when available; fall back to recomputing for safety. */
	const topicSlugs = story._topicSlugs
		|| new Set((story.taxonomies?.topic || []).map(topic => topic.slug));
	const industrySlugs = story._industrySlugs
		|| new Set((story.taxonomies?.industry || []).map(industry => industry.slug));

	/* If no filter is selected for a particular taxonomy, treat as a match */
	const isTopicMatch = topics.length === 0 || topics.some(topic => topicSlugs.has(topic));
	const isIndustryMatch = industries.length === 0 || industries.some(industry => industrySlugs.has(industry));

	return isTopicMatch && isIndustryMatch;
});
